import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useQualtricsStore = defineStore('qualtrics', () => {
  const showQualtrics = ref<boolean>(false)

  const setShowQualtrics = (value: boolean) => {
    showQualtrics.value = value
  }

  return {
    showQualtrics,
    setShowQualtrics
  }
})
